<script>
    import { getContext } from 'svelte';
    import { publishOpenAction } from './openable';
    import PlaygroundHelper from '../scripts/playgroundhelper';
    import FormatHelper from '../scripts/FormatHelper';

    /**
     * A group of photos posted by the same user for the same playground.
     */
    export let group;

    $: playground = group ? group.playground : null;
    $: playgroundTitle = PlaygroundHelper.presentPlayground(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(group, action);

    /**
     * Callback (group) => () for when the photos of a group have been handled.
     *
     * @type Function
     */
    export let groupHandled;

    /**
     * Callback (group) => () for when the group should be split into separate items.
     *
     * @type Function
     */
    export let groupSplit;

    let getMap = getContext('getMap');

    function groupClosed() {
        if (!group || !groupHandled) {
            return;
        }

        // The sidebar decides what is left of the group
        groupHandled(group);
    }

    function splitGroup() {
        if (!group || !groupSplit) {
            return;
        }

        groupSplit(group);
    }

    function action() {
        getMap().openApprovePhotoGroupPopup(group, groupClosed, splitGroup);
    }

</script>

<p>
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a href="#" on:click|preventDefault={action}>{group.photos.length} nya foton: {playgroundTitle}</a>
</p>
<p class="small-line">
    {FormatHelper.dateTime(group.date)}
</p>
<p class="small-line">
    <i class="far fa-images" />
    {group.photos.length} foton från samma användare
</p>

<style>
    p {
        margin: 0;
        padding: 0;
    }

    p.small-line {
        font-size: 12px;
    }
</style>
